import React, {Component, PropTypes} from 'react';
import ClientSideCacheController from '../ClientSideCacheController'
import UtilityBelt from './UtilityBelt';

import Cannonicalize from '../Cannonicalize';
class Banner extends Component {
  constructor(props) {
    super(props)
    this.debug = false;
    this.state = {
      active: false,
      alerts: Cannonicalize.banner(),
      collapsed: true,
      schoolsClosed: false,
      schoolClosingUrl: '',
      notifications: 0,
      liveFeedSources: []
    }
    this.origin = props.affiliate == 'kotv'
      ? 'http://www.newson6.com'
      : 'http://www.news9.com'

    this.initTime = 0;
    this.affiliate = props.affiliate;
    this.refreshDuration = 60 * 1000;
    this.slideDelay = 10 * 1000;
    this.transitionSpeed = 600;
    this.bannerChecker = null;
    this.bannerSlider = null;
    this.UtilityBeltHeight = 30;
    this.bannerCollapsedTimeout = 5 * 1000;
    this.bannerContainer = null
  }

  componentWillMount() {
    if (this.props.bannersFeed)
      this.updateAlerts(this.props.bannersFeed)

    if (typeof window === 'object')
      ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('banner', {debug: this.debug}) //fetches only if needed, data will be there in localStorage when we need it if ajax is complete
  }

  componentDidMount() {
    this.initTime = Date.now()

    ClientSideCacheController.get('banner', {debug: this.debug}).then(this.updateAlerts)
    this.bannerChecker = setInterval(() => {
      ClientSideCacheController.get('banner', {debug: this.debug}).then(this.updateAlerts)
    }, this.refreshDuration);

    this.bannerSlider = setInterval(() => {
      this.slideBanner()
    }, this.slideDelay);
    if (window) {
      window.onresize = this.makeSpaceForHeader;
    }
    this.makeSpaceForHeader()
    // if(this.bannerContainer.offsetWidth > 995){
    //   setTimeout(() => {
    //     this.setState({collapsed: false})
    //   },300)
    //   setTimeout(() => {
    //     this.setState({collapsed: true})
    //   }, this.bannerCollapsedTimeout)
    // }
  }

  updateAlerts = (alerts) => {

    alerts.banners = alerts.banners.filter(function(a) {
      return a.BannerTypeId != 1 //remove the school closings banner
    })
    alerts.banners.map((a, i) => {
      a.activeOrder = i;
    })
    this.setState({
      alerts: alerts.banners,
      active: alerts.banners.length > 0
        ? true
        : false,
      schoolsClosed: alerts.schoolsClosed,
      schoolClosingUrl: alerts.schoolClosingUrl,
      live: alerts.live,
      liveUrl: alerts.liveUrl
    })
  }

  slideBanner() {
    if (!this.state.collapsed)
      return null
    this.setState(function(prevState) {
      if (prevState.alerts.length == 0)
        return
      let newalerts = prevState.alerts.map((el, i, array) => {
        el.activeOrder = el.activeOrder != 0
          ? el.activeOrder - 1
          : array.length - 1;
        return el
      })
      return {alerts: newalerts}
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.active != prevState.active || this.state.collapsed != prevState.collapsed)
      this.makeSpaceForHeader();
    }

  componentWillUnmount() {
    clearInterval(this.bannerChecker);
    clearInterval(this.bannerSlider);
    this.makeSpaceForHeader();
  }

  makeSpaceForHeader = () => {
    /* css transition for this effect can be found both in Banner.css and global.css */
    var banner_height = this.state.active
      ? (
        this.state.collapsed
        ? 40
        : this.state.alerts.length * 40)
      : 0;

    var headerHeight = 101;

    if (typeof document.getElementById('gnm-header-without-banner') == 'object') {
      headerHeight = document.getElementById('gnm-header-without-banner').offsetHeight;
    }
    let new_padding = (headerHeight + banner_height + this.UtilityBeltHeight) + 'px';

    /* really hate touching the DOM, but I don't see any way out of this */
    if (document.getElementById('gnm-main-body'))
      document.getElementById('gnm-main-body').style.paddingTop = new_padding;

    /* for frankly layout only */
    if (document.querySelector('.PageGrid.PageBody.container'))
      document.querySelector('.PageGrid.PageBody.container').style.paddingTop = new_padding;

    //stupid wallpaper too
    if (document.getElementById('WallpaperAd')) {
      document.getElementById('WallpaperAd').style.backgroundPositionY = (- 25 - banner_height) + 'px';
    }

  }

  toggleCollapsed = (e) => {
    if (e)
      e.preventDefault()

    this.setState((prevState) => {
      return {
        collapsed: !prevState.collapsed
      }
    })
  }

  animatedStyle = (a, i) => {
    if (this.state.collapsed) {
      if (this.state.alerts.length == 1) {
        return {};
      }
      let transformPercent = 0;
      let zIndex = '-1'
      if (a.activeOrder == this.state.alerts.length - 1) {
        transformPercent = 100;
        zIndex = '1';
      }
      if (a.activeOrder == 0) {
        zIndex = '1';
      }
      return {
        zIndex: (this.state.alerts.length - a.activeOrder).toString(),
        transition: 'z-index ' + 6 *this.transitionSpeed + 'ms linear,  transform ' + this.transitionSpeed + 'ms ease-in-out',
        transform: 'translate3d(0,' + transformPercent + '%,0)'
      }
    } else {
      return {
        opacity: '1',
        zIndex: (this.state.alerts.length - a.activeOrder).toString(),
        transition: 'z-index 0ms, transform ' + this.transitionSpeed + 'ms ease-in-out',
        transform: 'translate3d(0,' + 100 *a.activeOrder + '%,0)'
      }
    }
  }

  animatedClass = (a, i) => {
    if (this.state.collapsed == true)
      return 'alert-red';

    if (a.activeOrder % 2 == 1)
      return 'alert-dark-red';
    return 'alert-red';
  }

  wrapperStyle() {
    if (this.state.collapsed) {
      if (this.state.active)
        return {
          height: 40 + this.UtilityBeltHeight + 'px'
        }
      else
        return {
          height: this.UtilityBeltHeight + 'px'
        }
      } else
      return {
        height: this.state.alerts.length * 40 + this.UtilityBeltHeight + 'px'
      }
    }

  render() {
    return (<div className={'gnm-banner '} id='gnm-banner' ref={(e)=>{this.bannerContainer = e}}>
      <div className='wrapper' style={this.wrapperStyle()}>
        <div className='container '>
          <button className='show-all' onClick={(e) => this.toggleCollapsed(e)} style={{
              display: this.state.alerts.length > 1
                ? 'block'
                : 'none'
            }}>
            <span className={(
                this.state.collapsed
                ? 'glyphicon glyphicon-plus'
                : 'glyphicon glyphicon-minus') + (
                this.state.collapsed
                ? ' collapsed'
                : '')}/>
          </button>
          <div className='alert-container'>

            {
              this.state.alerts.map((a, i) => {
                let strippedTitle = a.Title
                if(this.props.watchLiveSponsorship)
                  strippedTitle = a.Title.replace('Watch Live powered by')

                return (<div key={i} className='item ' style={this.animatedStyle(a, i)} role='option'>
                  <div className={'alert ' + this.animatedClass(a, i) + (
                      a.activeOrder == 0
                      ? ' active'
                      : '')} role='alert'>
                    <div className='line-clamp '>
                      <a href={a.Link} onClick={() => {
                          this.toggleCollapsed();
                        }}>
                        {a.Title === strippedTitle
                          ? <span>{a.Title}:</span>
                          : (<span>
                              <span>Watch Live powered by</span>
                              <img src={this.props.watchLiveSponsorship} />
                              <span>:</span>
                            </span>)
                        }

                        <span>{' ' + a.Description}</span>
                      </a>
                    </div>
                  </div>
                </div>)
              })
            }

          </div>
        </div>
      </div>
      <UtilityBelt affliate={this.affiliate} schoolsClosed={this.state.schoolsClosed} schoolClosingUrl={this.state.schoolClosingUrl} live={this.state.live} style={{
          height: this.UtilityBeltHeight + 'px'
        }}/>

    </div>)
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/Banner.js